import React from 'react';

const ModalDescription = () => {
  return (
    <div className="test-modal-description">
      <p className="test-modal-description-text">You are one step closer to your dream job! The Turing team will be with you throughout the process. Here&apos;s what you need to do next:</p>
    </div>
  );
};

export default ModalDescription;
